import React from 'react';

import '../icon-component.scss';

const ChevronComponent = () => (
  <svg className="icon-component" style={{ width: '8px', height: '12px' }} viewBox="0 0 12 8">
    <path d="M6,7.21 L0.65,1.86 C0.453938914,1.66393891 0.453938914,1.34606109 0.65,1.15 C0.846061086,0.953938914 1.16393891,0.953938914 1.36,1.15 L6,5.79 L10.65,1.14 C10.7768293,1.01317072 10.961687,0.963638242 11.134939,1.01006098 C11.308191,1.05648372 11.4435163,1.19180896 11.489939,1.36506098 C11.5363618,1.53831301 11.4868293,1.72317072 11.36,1.85 L6,7.21 Z" />
  </svg>
);

ChevronComponent.displayName = 'ChevronIcon';

export default ChevronComponent;
